import {gql} from 'apollo-angular';
import { Page } from '../../entities/page/page';
import { EntityLink } from '../../entities/entityLink/entityLink';
import { LinkedEntityConnection } from '../../entities/entityLink/linkedEntityConnection';

// export const GET_ENTITY_LINKS_QUERY = gql`
// query getEntityLinksPaged($outwardEntityId: UUID, $inwardEntityType: String)
// {
//   getEntityLinksPaged: getEntityLinksPaged(
//     filter: {
//       outwardEntityId: $outwardEntityId,
//       inwardEntityType: $inwardEntityType,
//       sortRequest: { sortProperties: ["id"], sortDirection: "asc" },
//       pagination: { number: 0, size: 10,  sortProperty: "id", sortDirection: "asc"}
//     }
//   ){
//     totalPages
//     totalElements
//     number
//     size
//     content{
//       id
//       outwardEntityId
//       outwardEntityType
//       inwardEntityId
//       inwardEntityType
//       linkType
//       linkedEntity{
//         id
//         entityType
//         text
//       }
//     }
//   }
// }
// `;

// export interface getEntityLinksPagedResponse {
//   issues: Page<EntityLink>;
//   loading: boolean;
// }

// New query using LinkedEntityConnection for perspective-based display
export const GET_LINKED_ENTITIES_QUERY = gql`
query getLinkedEntities(
    $entityId: UUID!,
    $linkedEntityType: String,
    $linkType: EntityLinkType,
    $pagination: Pagination,
    $sortRequest: SortRequest
) {
  getLinkedEntities(
    entityId: $entityId,
    linkedEntityType: $linkedEntityType,
    linkType: $linkType,
    pagination: $pagination,
    sortRequest: $sortRequest
  ){
    totalPages
    totalElements
    number
    size
    content{
      linkId
      requestingEntityId
      linkType
      perspective
      linkLabel
      role
      isSystemManaged
      linkedEntity{
        ... on Task {
          id
          text
          entityType
        }
        ... on Resource {
          id
          text
          entityType
        }
        ... on Order {
          id
          text
          entityType
        }
        ... on Contact {
          id
          text
          entityType
        }
      }
    }
  }
}
`;

export interface getLinkedEntitiesResponse {
  getLinkedEntities: Page<LinkedEntityConnection>;
}
